<template>
  <button class="cta" type="button" :disabled="disabled" @click="$emit('click')">
    <span class="cta__label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'CtaButton',
  props: {
    label: {type: String, required: true},
    disabled: {type: Boolean, default: false}
  },
  emits: ['click']
}
</script>

<style scoped>
.cta {
  position: absolute;
  top: calc(645 * var(--u));
  left: calc(57 * var(--u));
  width: calc(261 * var(--u));
  height: calc(64 * var(--u));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: calc(8 * var(--u));
  background-color: var(--slate);
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
}

.cta:active:not(:disabled) {
  transform: translateY(calc(1 * var(--u)));
}

.cta:disabled {
  cursor: not-allowed;
  opacity: 0.75;
}

.cta__label {
  font-size: calc(16.3 * var(--u));
  line-height: 1;
  font-weight: 700;
  letter-spacing: calc(0.2 * var(--u));
  color: #FFFFFF;
}
</style>
